import { i18n } from "../../boot/i18n";
// import { store } from "../../store";

export default {
  routes: [
    {
      name: "customer-feedback",
      path: "/feedback/:feedbackID",
      props: true,
      meta: {
        icon: "feedback",
        title: i18n.global.t("Customer Feedback"),
      },
      component: () => import("pages/customer/Feedback"),
    },
    {
      name: "sample-public",
      path: "/sample/:sampleID",
      props: true,
      meta: {
        icon: "sample",
        title: i18n.global.tc("Sample"),
      },
      component: () => import("pages/public/SampleScan"),
    },
  ],

  dialogs: [
    {
      name: "account",
      path: "/account",
      component: () => import("../../dialogs/admin/UserEdit"),
    },

    {
      name: "whats-new",
      path: "/whats-new",
      component: () => import("../../dialogs/WhatsNew"),
    },

    {
      name: "notification-settings",
      path: "/notifications/settings",
      component: () => import("../../dialogs/NotificationSettings"),
    },
    {
      name: "user-notification-settings",
      path: "/admin/users/:userID/notifications",
      component: () => import("../../dialogs/NotificationSettings"),
    },
    {
      name: "notification-view",
      path: "/notifications/view/:id",
      component: () => import("../../dialogs/Notification"),
    },
    {
      name: "reminder-view",
      path: "/notifications/reminders/view/:id",
      component: () => import("../../dialogs/Notification"),
    },
    {
      name: "snooze",
      path: "/notifications/snooze/:id",
      component: () => import("../../dialogs/Snooze"),
    },
    {
      name: "reschedule",
      path: "/notifications/reminders/reschedule/:id",
      component: () => import("../../dialogs/Snooze"),
    },

    {
      name: "image",
      path: "/image/:src/:title",
      component: () => import("../../dialogs/ImageViewer"),
    },
    {
      // The same viewer as a gallery: `images` is a JSON list of
      // { src, title, original } (see ImageViewer), opened at `index`.
      // Build it with `imageGalleryRoute`.
      name: "images",
      path: "/images/:images/:index",
      component: () => import("../../dialogs/ImageViewer"),
    },
    {
      name: "video",
      path: "/video/:src/:title",
      component: () => import("../../dialogs/VideoViewer"),
    },
    {
      name: "pdf",
      path: "/pdf/:src/:title",
      component: () => import("../../dialogs/PDFViewer"),
    },
  ],
};
